import classNames from "classnames";
import { LocalStorage, USER_TYPE, USER_TYPE_LABEL } from "../../models/LocalStorage";
import { getParamUrl } from "../../utils/url";
import { DComponent } from "../DComponent";
import { FireBase } from "../../utils/firebase";
import { apiRefreshToken } from "../../utils/api";
import MenuDropDown from "../MenuDropDown";
import { MENU_DESKTOP_USER } from "../../utils/menu";
import { listenEvent, EVENTS } from "../../utils/event";
import { DCStatic } from "../../models/DCStatic";
import { isMobile } from "../../utils/utils";
import { ROOT_GLOBAL } from "../../global/root";

export default class UserBox extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    showGuest = false
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("UserBox", {
        "show-guest": showGuest
      }),
      classCollaborator: LocalStorage.getTierFromToken() !== USER_TYPE.TYPE_COLLABORATOR ? "hide" : ""
    }, true, defaultLoading);
    this.showGuest = showGuest;
    /** @type {MenuDropDown} */
    this.menuDropDown = undefined;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "UserBox");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.setUpEvent();
    this.setPage();
    this.showUserInfo();

    listenEvent(EVENTS.CHANGE_AUTH_STATUS, () => this.showUserInfo());
  }

  changeParent(parent) {
    parent.append(this.element);
    this.parent = parent;
  }

  setPage() {
    const page = getParamUrl("page");
    const isLoggedIn = LocalStorage.isLoggedIn();
    switch (page) {
      case "login":
      case "signup":
      case "login-phone":
        if (!isLoggedIn) DCStatic.authSocial.showAuth();
        break;
      default:
        break;
    }
  }

  showUserInfo() {
    let displayName = "";
    const isLoggedIn = LocalStorage.isLoggedIn();
    const tier = LocalStorage.getTierFromToken();
    if (isLoggedIn) {
      $(".main-page").removeClass("unloggedin").addClass("loggedin");
      displayName = LocalStorage.getUserName();
      $(".main-page").addClass(USER_TYPE_LABEL[tier]);
      if (tier === USER_TYPE.TYPE_COLLABORATOR) {
        $(".item.collaboratorDashboard", this.element).removeClass("hide");
      } else {
        $(".item.collaboratorDashboard", this.element).addClass("hide");
      }
      FireBase.getUpdatedUser((data) => {
        if (data && +data > +LocalStorage.getIat()) {
          apiRefreshToken();
        }
      });
    } else {
      if (this.showGuest) displayName = $.i18n("menu_guestUser");
      $(".main-page").removeClass("loggedin").addClass("unloggedin");
    }
    $(".hello .name", this.element).text(displayName);
    $(".hello .name", this.element).attr("title", displayName);
    this.element.attr("data-login", isLoggedIn ? "loggedin" : "unloggedin");
  }

  setUpEvent() {
    $("body").on("click", ".login-signup", (e) => {
      if (window.location.pathname.includes(ROOT_GLOBAL.BECOME_OUR_MERCHANT) || window.location.pathname === ROOT_GLOBAL.HOME_PAGE_US || DCStatic.ipCountry === "US") {
        DCStatic.isMerchant = true;
      }
      DCStatic.authSocial.showAuth();
    });

    $("body").on("mouseenter", ".hello.only-loggedin", (e) => {
      if (!this.menuDropDown && !isMobile()) {
        this.menuDropDown = new MenuDropDown({
          parent: $(".hello.only-loggedin", this.element),
          menuItems: MENU_DESKTOP_USER,
          position: "left",
          width: "220px",
        })
      }
    })
  }
}